/* ---------------------------------------------------------------------------------
	Account page
	---------------------------------------------------------------------------------*/

$(function() {
  if (window.location.pathname.indexOf('account') > -1) {

    // $('.carousel').carousel({
    //   interval: false,
    //   wrap:true
    // })

    // Add widget classname to appropriate section depending on device screen width
    if ($(window).width() > 767) {
    	$('.tabbedSectionWrapper .lincWidgetWrapper div').addClass('linc-optin-widget');
    } else {
    	$('.tabbedSectionWrapperAccordian .lincWidgetWrapper div').addClass('linc-optin-widget');
    }

  	var AccountPage = AccountPage || {};

  	AccountPage.closeModalReturn = function(e) {
  		e.preventDefault();
  		var $el = $(e.target);

  		$el.closest('.modal-open').hide();
  		$('.skipConfirmationModal').hide();
  		$('.div__switchWarning').hide();
  		$('.chooseSubscriptionMessage').hide();
  		$('.collectionDetailsWrapper .product-images').show();
      $('.collectionDetailsWrapper .product-description').show();
  		$('body').removeClass('noScroll');
  		location.href="#shopify-section-account-tabbed-section";
  	}

  	AccountPage.closeUpdateSizes = function(e) {
  		e.preventDefault();

  		var $el = $(e.target);
  		$el.closest('.modal-content').find('.sizeConfirmation').remove();
  		$el.closest('.modal').hide();

  		$('.updateSizesForm').show();
  		$('.account_sizes h4').show();
  	}

  	AccountPage.closeSkipModal = function(e) {
  		e.preventDefault();

  		var $el = $(e.target);
  		$el.closest('.modal').hide();
  		$('.tab').removeClass('selected-tab');
  		$('.panel').hide();
  		$('.chooseSubscriptionMessage').hide();
  		$('.skipConfirmationModal').hide();

  		if ($(window).width() > 798) {
  			showTab1Desktop();
  		}
  	}

  	AccountPage.openSkipMonthModal = function(e) {
  		var subscriptionID = $('#selectCustomerSubscription').val();

  		//If no subscription selected, show message
  		if (subscriptionID.length < 2) {
  			$('.skip-modal').show();
  			$('.skip-modal h3').hide();
  			$('.skipFormWrapper').hide();
  			$('.skip-modal .chooseSubscriptionMessage').show();
  		} else { // else show Skip Reason Modal
  			$('.skip-modal').show();
  			$('.skip-modal h3').show();
  			$('.skipFormWrapper').show();

  			var subscriptionID = $('#selectCustomerSubscription').val();
  			var chargedate;
  			var productname;

  			$('#selectCustomerSubscription option').each(function() {
  				if ($(this).val() == subscriptionID) {
  					chargedate = $(this).text().split(': ')[1];
  					productname = $(this).text().split('. ')[1].split(':')[0];
  				}
  			})

  			$('#skip_subscription_id').val(subscriptionID);
  		}
  	}

  	AccountPage.showNextCollectionDetail = function(e) {
  		$('.collectionDetailsWrapper').each(function() {
  			if ($(this).css('display') == 'block' && $(this).next().hasClass('nextPrevWrapper')) {
  				$(this).prev().prev().prev().prev().prev().show();
          $(this).hide();
  				// reloadSliders1Thru3($(this));
  				return false;
  			}
  			if ($(this).css('display') == 'block' && $(this).next().hasClass('collectionDetailsWrapper')) {
  				$(this).next().show();
          $(this).hide();
  				// reloadSliders1Thru3($(this));
  				return false;
  			}
  		})
  	}

  	AccountPage.showPrevCollectionDetail = function(e) {
  		$('.collectionDetailsWrapper').each(function() {
  			if ($(this).css('display') != 'none' && $(this).prev().hasClass('collectionDetailsWrapper')) {
  				$(this).prev().show();
          $(this).hide();
  				// reloadSliders1Thru3($(this));
  				return false;
  			}
  			if ($(this).css('display') != 'none' && !$(this).prev().hasClass('collectionDetailsWrapper')) {
  				$(this).next().next().next().next().next().show();
          $(this).hide();
  				// reloadSliders1Thru3($(this));
  				return false;
  			}
  		})
  	}

  	AccountPage.goBackToTab1 = function() {
  		$('.tab-1').addClass('selected-tab');
  		$('.tab-1').siblings().removeClass('selected-tab');
  		$('.panel-1').show();
  		$('.panel-1').siblings().hide();
  	}

  	// If no sizes available for selected collection, this link leads them to the update sizes view
  	AccountPage.goToUpdateSizesView = function(e) {
  		e.preventDefault();
  		var $el = $(e.target);

  		$el.closest('.modal-open').hide();
  		$('.skipConfirmationModal').hide();
  		$('.collectionDetailsWrapper .product-images').show();
  	  $('.collectionDetailsWrapper .product-description').show();
  		location.href="#shopify-section-account-tabbed-section";
  		$('.tab-3').addClass('selected-tab');
  		$('.tab-3').siblings().removeClass('selected-tab');
  		$('.panel-3').show();

  		$('.panel').each(function() {
  			if (!$(this).hasClass('panel-3')) {
  				$(this).hide();
  			}
  		})
  	}

  	AccountPage.goToSwitchConfirmation = function(e) {
  		var $el = $(e.target);

  		$('.nextPrevWrapper').hide();
  		$el.closest('.collectionDetailsWrapper').find('.product-images').hide();
  		$el.closest('.collectionDetailsWrapper').find('.product-description').hide();
  		$el.closest('.collectionDetailsWrapper').find('.nextPrevWrapper').hide();
  		$el.closest('.collectionDetailsWrapper').find('.div__switchWarning').show();
  	}

  	AccountPage.cancelSwitchCollection = function(e) {
  		$('.div__switchWarning').hide();
  		$('.skipConfirmationModal').hide();
  		$('.collectionDetailsWrapper .product-images').show();
  		$('.collectionDetailsWrapper .product-description').show();
  		$('.nextPrevWrapper').show();
  	}

  	AccountPage.previewCurrentCollection = function(e) {
  		var $el = $(e.target);
  		var productHandle = $el.closest('.thisMonthsCollection').find('.btn').attr('aria-labelledby');

  		$('.nextPrevWrapper').show();

  		if (!$('#selectCustomerSubscription').val().length) {
  			$('.goToSwitchConfirmation').prop('disabled', true);
  		}
  		// console.log('productHandle', productHandle)
  		$('.collectionDetailsWrapper').each(function() {
  			if ($(this).attr('aria-labelledby') == productHandle) {
  				$(this).show();
  				// console.log('aria-labelledby', $(this).attr('aria-labelledby'))

  				setTimeout(function() {
  					// slider1.reloadSlider();
  					// slider2.reloadSlider();
  					// slider3.reloadSlider();
  					// slider4.reloadSlider();
          	// slider5.reloadSlider();
          	// slider6.reloadSlider();
            // slider7.reloadSlider();
  					$(this).find('li').each(function() {
  						$(this).css('left', '0px');
  					})
  				}, 500);
  			}
  			else {
  				console.log('hide:', $(this).attr('aria-labelledby'))
  				$(this).hide();
  			}
  		})

  		$('.skipConfirmationModal').hide();
  		$('.div__switchWarning').hide();
  		$('body').addClass('noScroll');
  		// console.log('addClass!')
  		$('.collectionDetailsModal').show();

  	}

  	AccountPage.openTabPanelDesktop = function(e) {
  		var $el = $(e.target);
  		// console.log('clicked')
  		// TODO: Grey SKip Button
  		if ($el.attr('data-disabled')) {
  			return false;
  		}

  		$('.modal-warning').remove();
  		$el.addClass('selected-tab');
  		$el.siblings().removeClass('selected-tab');
  		$('.panel').each(function() {
  			if ($(this).attr('aria-labelledby') == $el.attr('aria-labelledby')) {
  				$(this).show();
  			}
  			else {
  				$(this).hide();
  			}
  		})
  	}

  	// AccountPage.openTabPanelMobile = function(e) {
  	// 	var $el = $(e.target);
  	// 	var id = $el.attr('id');
  	// 	var linkToDiv = '#' + id;
  	// 	var selection = $('#selectCustomerSubscription').val();
  	//
  	// 	if ($el.hasClass('selected-tab')) {
  	// 		$el.removeClass('selected-tab');
  	//
  	// 		$('.tabbedSectionWrapperAccordian .panel').each(function() {
  	// 			if ($(this).attr('aria-labelledby') == $el.attr('aria-labelledby')) {
  	// 				$(this).hide();
  	// 			}
  	// 		})
  	// 	} else {
  	// 		$el.addClass('selected-tab');
  	// 		$el.siblings().removeClass('selected-tab');
  	//
  	// 		$('.tabbedSectionWrapperAccordian .panel').each(function() {
  	// 			if ($(this).attr('aria-labelledby') == $el.attr('aria-labelledby')) {
  	// 				$(this).show();
  	// 			}
  	// 			else {
  	// 				$(this).hide();
  	// 			}
  	// 		})
  	//
  	// 		if (selection.length < 2) {
  	// 			noSubscriptionSelected();
  	// 			return false;
  	// 		}
  	//
  	// 		addYourPickIconMobile();
  	//
  	// 		location.href = linkToDiv;
  	//
  	// 	}
  	// }

  	AccountPage.handleSubscriptionSelection = function(e) {
  		var selection = $('#selectCustomerSubscription').val();
  		var sizeArray;
  		var selectedCollection;
  		var selectedCollectionHandle;
  		var altCollectionChosen;
  		var chargeDate;
        var chargeNull;

  		var today = new Date();
  		var thisMonth = today.getMonth() + 1;
  		thisMonth = parseInt(thisMonth);



  		// If no subscription selected:
  		if (selection.length < 2) {
  			noSubscriptionSelected();

  			$('.tabbedSectionWrapper .tab-1').addClass('selected-tab');
  			$('.tabbedSectionWrapper .tab-1').siblings().removeClass('selected-tab');
  			$('.tabbedSectionWrapper .panel-1').show();
  			$('.tabbedSectionWrapper .panel-1').siblings().hide();
  			$('.skipButtonsWrapper').show();
  			$('.skipThisMonthMessage').text('You may skip a month between the 1st and the 4th of the month. Are you sure you want to skip your subscription this month?');
  			$('.subChargeDateWrapper').hide();
  			$('.editSizes').attr('disabled', true);

  			// TODO: 01/2019 Grey Skip
  			$('.tabsWrapper .tab-2').css('cursor', 'pointer').css('color', '#333');
  			$('.tabsWrapper .tab-2').attr('data-disabled', false);
  			$('.showOnMobile798 .tab-2').css('cursor', 'pointer').css('color', '#333');
  			$('.showOnMobile798 .tab-2').attr('data-disabled', false);

  			return false;
  		}

  		$('.editSizes').attr('disabled', false);
  		$('.goToSwitchConfirmation').prop('disabled', false);

  		// console.log('selection', selection);

  		$('#selectCustomerSubscription option').each(function() {
  			if ($(this).val() == selection) {
  				sizeArray = $(this).attr('aria-labelledby').split(',<br> ');
  				selectedCollection = $(this).text().split(' -')[0].split('. ')[1];
  				// console.log('selectedCollection', selectedCollection);
  				selectedCollectionHandle = selectedCollection.replace(new RegExp(' ', 'g'), '-').toLowerCase().replace("'", "");
  				chargeDate = $(this).text().split(': ')[1];

              //           9/24/19 Charge_null
                chargeNull = $(this).attr('data-charge_null');

              if (chargeNull == 'true') {
                $('.chargeNullWarning').show();
                console.log('show')
              } else {
              	$('.chargeNullWarning').hide();
                console.log('hide')
              }
              //           End 9/24/19 Charge_null

  				$('.subChargeDate').text(chargeDate);
  				$('.subChargeDateWrapper').show();

  				var dataprodid = $(this).attr('data-prodid');

  				if (dataprodid !== undefined) {
  					altCollectionChosen = false;
  				} else {
  					altCollectionChosen = true;
  				}

  				// Change Skip This Month message & hide buttons if sub has chargedate past current month
//   				var chargeDateInteger = parseInt(chargeDate.split('-')[1].split('-')[0]);
  				// console.log('charge', chargeDateInteger);

  				// console.log('altCollectionChosen: ', altCollectionChosen)

  				var skippable = $(this).attr('data-skippable');

  				if (skippable == 'false') {
            //Allow skip for Boss Babe 2/10/2020
            if (selectedCollection.indexOf('Boss') > -1) {
              $('.skipButtonsWrapper').show();
  						$('.skipThisMonthMessage').text('You may skip a month between the 1st and the 4th of the month. Are you sure you want to skip your subscription this month?');
            } else {
              $('.skipButtonsWrapper').hide();
              $('.skipThisMonthMessage').text('You have already skipped this month. You may skip again between the 1st and the 4th of next month.');
            }
  				} else {
  					if (altCollectionChosen) {
  						$('.skipButtonsWrapper').hide();
  						$('.skipThisMonthMessage').text('You have already selected an alternate collection for this month. You may skip again between the 1st and the 4th of next month.');

  						// TODO: 01/2019 Grey Skip
  						// $('.tabsWrapper .tab-2').css('cursor', 'default').css('color', 'gray');
  				    // $('.tabsWrapper .tab-2').attr('data-disabled', true);
  				    // $('.showOnMobile798 .tab-2').css('cursor', 'default').css('color', 'gray');
  				    // $('.showOnMobile798 .tab-2').attr('data-disabled', true);
  					} else {
  						$('.skipButtonsWrapper').show();
  						$('.skipThisMonthMessage').text('You may skip a month between the 1st and the 4th of the month. Are you sure you want to skip your subscription this month?');
  					}
  				}

  				return false;
  			}
  		})

  		$('.hideOnMobile798 .thisMonthsCollection').each(function() {
  			// if ($(this).find('h4').text() == selectedCollection) {
  			var thisMonthsCollectionText = $(this).find('h4').text();

  			// console.log('thisMonthsCollectionText', thisMonthsCollectionText)
  			// console.log('selectedcollection', selectedCollection)

  			if (selectedCollection.indexOf(thisMonthsCollectionText) > -1) {
  				var collectionHandle = $(this).find('button.previewCurrentCollection').attr('aria-labelledby');

  				addYourPickIcon($(this));

  				markSelectedCollectionDisableOthers(collectionHandle, altCollectionChosen);

  				return false;
  			}
  		})

  		$('.showOnMobile798 .thisMonthsCollection.item').each(function() {
  			var thisMonthsCollectionText = $(this).find('h4').text();

  			if (selectedCollection.indexOf(thisMonthsCollectionText) > -1) {
  				var collectionHandle = $(this).find('button.previewCurrentCollection').attr('aria-labelledby');

  				addYourPickIcon($(this));

  				markSelectedCollectionDisableOthers(collectionHandle, altCollectionChosen);

          $(this).siblings().removeClass('active');
          $(this).addClass('active');
  				// if ($('#tab-1').hasClass('selected-tab')) {
  				// 	var index = $('.thisMonthsCollection.lslide').index($(this));
  				// 	lightSliderMobile.goToSlide(index + 1)
  				// }

  				return false;
  			}
  		})

  		// console.log('sizeARRAY', sizeArray);

  		var bottomSize = sizeArray[0].split(': ')[1];
  		var braSize = sizeArray[1].split(': ')[1];
  		var topSize = sizeArray[2].split(': ')[1];
  		var jacketSize = sizeArray[3] ? sizeArray[3].split(': ')[1] : sizeArray[2].split(': ')[1];
  		var glovesSize = sizeArray[4] ? sizeArray[4].split(': ')[1] : sizeArray[0].split(': ')[1];
  		var subscriptionID = $(this).closest('tr').find('td:nth-child(5)').eq(0).text();
  		var productName = $(this).closest('tr').find('td:nth-child(1)').eq(0).text();

  		$('.sizeConfirmationWrapper .topSize').text(topSize);
  		$('.sizeConfirmationWrapper .bottomSize').text(bottomSize);
  		$('.sizeConfirmationWrapper .braSize').text(braSize);
  		$('.sizeConfirmationWrapper .jacketSize').text(jacketSize);
  		$('.sizeConfirmationWrapper .glovesSize').text(glovesSize);
  		// console.log('glovesSize', glovesSize)

  		// console.log('selectedCollectionHandle', selectedCollectionHandle)

  		$('.soldOutWrapper').each(function() {
  			if ($(this).attr('aria-labelledby').indexOf(selectedCollectionHandle) > -1) {
  				// console.log('disableUnavailableVariants!')
  				if ($(this).find('input[name="soldOutVariants"]').length) {
  					// console.log('disableUnavailableVariants!')
  					disableUnavailableVariants($(this));
  				}
  			} else {
  				$('.sizeUnavailable').each(function() {
  					$(this).remove();
  				})
  			}
  		})
  	}

  	AccountPage.editSizes = function(e) {
  		var $el = $(e.target);
  		var sizes;
  		var selectedCollectionHandle;
  		var selectedCollection;
  		var subscriptionID = $('#selectCustomerSubscription').val();

  		$('#selectCustomerSubscription option').each(function() {
  			if ($(this).val() == subscriptionID) {
  				sizes = $(this).attr('aria-labelledby').split(',<br> ');
  				selectedCollection = $(this).text().split(' -')[0].split('. ')[1];
  				selectedCollectionHandle = selectedCollection.replace(new RegExp(' ', 'g'), '-').toLowerCase();
  			}
  		})

  		var bottomSize = sizes[0].split(':')[1].trim();
  		var braSize = sizes[1].split(':')[1].trim();
  		var topSize = sizes[2].split(':')[1].trim();
  		var jacketSize = sizes[3] ? sizes[3].split(':')[1].trim() : sizes[2].split(':')[1].trim();
  		var glovesSize = sizes[4] ? sizes[4].split(':')[1].trim() : sizes[0].split(':')[1].trim();

  		$('.account_sizes #subscript_id').attr('value', subscriptionID);
  		$('.collectionDetailsModal').hide();
  		$('.updateSizesModal').show();

  		// Grey out unavailable sizes
  		$('.soldOutWrapper').each(function() {
  			if ($(this).attr('aria-labelledby').indexOf(selectedCollectionHandle) > -1) {
  				if ($(this).find('input[name="soldOutVariants"]').length) {
  					greyOutUnavailableSizes($(this));
  				} else {
  					enableAllVariants()
  				}
  			}
  		})

  		// Select first available variant
  		// setTimeout(function() {
  		// 	selectFirstAvailableVariant();
  		// }, 500);

  		// Preselect currest existing sizes on update size view
  		setTimeout(function() {
  			$('select[name="Bra_Size"] option').each(function() {
  				populateSizesOnUpdateSizesView($(this), braSize);
  			})

  			$('select[name="Bottom_Size"] option').each(function() {
  				populateSizesOnUpdateSizesView($(this), bottomSize);
  			})

  			$('select[name="Top_Size"] option').each(function() {
  				populateSizesOnUpdateSizesView($(this), topSize);
  			})

  			$('select[name="Jacket_Size"] option').each(function() {
  				populateSizesOnUpdateSizesView($(this), jacketSize);
  			})
  			$('select[name="Gloves_Size"] option').each(function() {
  				populateSizesOnUpdateSizesView($(this), glovesSize);
  			})
  		}, 800);
  	}


  	/* --- Event Handlers (Account Page) ------------------------------*/
  	$(function() {
  		$('.close-modal-return').on('click', AccountPage.closeModalReturn);
  		$('#close-update-sizes').on('click', AccountPage.closeUpdateSizes);
  		$('.close-skip-modal').on('click', AccountPage.closeSkipModal);
  		$('.openSkipMonthModal').on('click', AccountPage.openSkipMonthModal);
  		$('.nextCollectionDetail').on('click', AccountPage.showNextCollectionDetail);
  		$('.prevCollectionDetail').on('click', AccountPage.showPrevCollectionDetail);
  		$('.goBackToTab1').on('click', AccountPage.goBackToTab1);
  		$('.modal-content').on('click', '.goToUpdateSizes', AccountPage.goToUpdateSizesView);
  		$('.goToSwitchConfirmation').on('click', AccountPage.goToSwitchConfirmation);
  		$('.div__switchWarning .warningCancel').on('click', AccountPage.cancelSwitchCollection);

  		$('.previewCurrentCollection').on('click', AccountPage.previewCurrentCollection);
  		$('.tabsWrapper .tab').on('click', AccountPage.openTabPanelDesktop);
  		// $('.tabbedSectionWrapperAccordian .tab').on('click', AccountPage.openTabPanelMobile);

  		$('#selectCustomerSubscription').on('change', AccountPage.handleSubscriptionSelection);
  		$('.editSizes').on('click', AccountPage.editSizes);

      // Bootstrap Carousel Override
      $('.left.carousel-control').click(function(e) {
        e.stopPropagation();
        var sliderID = $(this).closest('.carousel').attr('id');
        $('#' + sliderID).carousel('prev');
      })
      $('.right.carousel-control').click(function(e) {
        e.stopPropagation();
        var sliderID = $(this).closest('.carousel').attr('id');
        $('#' + sliderID).carousel('next');
      })
      $('.carousel-indicators li').click(function(e){
        e.stopPropagation();
        var goTo = $(this).attr('data-slide-to');
        var sliderID = $(this).closest('.carousel').attr('id');
        $('#' + sliderID + ' .carousel-inner .item').each(function(index){
            if($(this).attr('data-id') == goTo){
                goTo = index;
                return false;
            }
        });

        $('#' + sliderID).carousel(goTo);
      });

  		appendSliderArrows('#shopify-section-account-ellie-exclusives');

  		if (window.location.pathname.indexOf('account') > -1) {
  			$('#shopify-section-faq-excerpt').css('background-color', 'transparent');

  			if ($(window).width() > 798) {
  				if (window.location.search.indexOf('tab-4') > -1) {
  					$('.tab-4').addClass('selected-tab');
  					$('.tab-4').siblings().removeClass('selected-tab');

  					$('.panel-4').show();
  					$('.panel-4').siblings().hide();
  				} else if (window.location.search.indexOf('tab-8') > -1) {
  					$('.tab-8').addClass('selected-tab');
  					$('.tab-8').siblings().removeClass('selected-tab');

  					$('.panel-8').show();
  					$('.panel-8').siblings().hide();
  				} else if (window.location.search.indexOf('tab-9') > -1) {
  					$('.tab-9').addClass('selected-tab');
  					$('.tab-9').siblings().removeClass('selected-tab');

  					$('.panel-9').show();
  					$('.panel-9').siblings().hide();
  				}
  			} else {
  				if (window.location.search.indexOf('tab-4') > -1) {
  					$('.tab-4').addClass('selected-tab');
  					$('.tab-4').siblings().removeClass('selected-tab');

  					$('.tabbedSectionWrapperAccordian .panel').each(function() {
  						if ($(this).attr('aria-labelledby') == 'tab-4') {
  							$(this).show();
  						}
  						else {
  							$(this).hide();
  						}
  					})
  				} else if (window.location.search.indexOf('tab-8') > -1) {
  					$('.tab-8').addClass('selected-tab');
  					$('.tab-8').siblings().removeClass('selected-tab');

  					$('.tabbedSectionWrapperAccordian .panel').each(function() {
  						if ($(this).attr('aria-labelledby') == 'tab-8') {
  							$(this).show();
  						}
  						else {
  							$(this).hide();
  						}
  					})
  				} else if (window.location.search.indexOf('tab-9') > -1) {
  					$('.tab-9').addClass('selected-tab');
  					$('.tab-9').siblings().removeClass('selected-tab');

  					$('.tabbedSectionWrapperAccordian .panel').each(function() {
  						if ($(this).attr('aria-labelledby') == 'tab-9') {
  							$(this).show();
  						}
  						else {
  							$(this).hide();
  						}
  					})
  				} else if (window.location.search.indexOf('tab-1') > -1) {
  					$('.tab-1').addClass('selected-tab');
  					$('.tab-1').siblings().removeClass('selected-tab');

  					$('.tabbedSectionWrapperAccordian .panel').each(function() {
  						if ($(this).attr('aria-labelledby') == 'tab-1') {
  							$(this).show();
  						}
  						else {
  							$(this).hide();
  						}
  					})

  					addYourPickIconMobile();

  					showSelectedCollection($('.showOnMobile798 .tab-1'));
  				}
  			}

  			$('.collectionDetailsWrapper').each(function() {
  				if ($(this).attr('aria-labelledby').indexOf('color-theory') > -1 || $(this).attr('aria-labelledby').indexOf('street-smarts-2-5-items') > -1 ) {
  					$(this).find('.goToSwitchConfirmation').attr('disabled', true);
  				}
  			})
  		}

  		// TODO: Skipping reason freeform
  		$('.skipFormWrapper input').click(function() {
  			if ($(this).val() == 'other') {
  				$('#skipping-reason-freeform').show();
  			} else {
  				$('#skipping-reason-freeform').hide();
  			}
  		})

      // Acount page: destroy lightslider when panel-1 closed (Mobile)
    	$('.showOnMobile798 .tab').click(function() {
    		openTabPanelMobile($(this));
    	})

  		// TODO: Disable switching to fierce & floral
  		$('.previewCurrentCollection[aria-labelledby="fierce-floral-5-items"]').css('disabled', true);
  	})

  	/* --- Function definitions (Account Page) ------------------------------*/
  	function showTab1Desktop() {
  		$('.tab-1').addClass('selected-tab');
  		$('.tab-1').siblings().removeClass('selected-tab');
  		$('.panel-1').show();
  		$('.panel-1').siblings().hide();
  	}

  	function reloadSliders1Thru3(e) {
  		e.hide();

  		setTimeout(function() {
  			slider1.reloadSlider();
  			slider2.reloadSlider();
  			slider3.reloadSlider();
  			slider4.reloadSlider();
      	slider5.reloadSlider();
      	slider6.reloadSlider();
        slider7.reloadSlider();
  		}, 500);
  	}

  	function noSubscriptionSelected() {
  		$('.thisMonthsCollection').each(function() {
  			$(this).find('.checkmarkIcon').remove();
  		})
  		$('.sizeConfirmationWrapper .topSize').text('');
  		$('.sizeConfirmationWrapper .bottomSize').text('');
  		$('.sizeConfirmationWrapper .braSize').text('');
  		$('.sizeConfirmationWrapper .jacketSize').text('');
  		$('.sizeUnavailable').remove();

  		$('.goToSwitchConfirmation').text('Select');
  		$('.selectedColWarning').remove();

  		$('.goToSwitchConfirmation').prop('disabled', true);
  	}

  	function addYourPickIconMobile() {
  		var selectedCollection;
  		var subscriptionID = $('#selectCustomerSubscription').val();

  		$('#selectCustomerSubscription option').each(function() {
  			if ($(this).val() == subscriptionID) {
  				selectedCollection = $(this).text().split(' -')[0].split('. ')[1];
  			}
  		})

  		setTimeout(function() {
  			$('.showOnMobile798 .thisMonthsCollection.lslide').each(function() {
  				if ($(this).find('h4').text() == selectedCollection) {

  					if (!$(this).find('.checkmarkIcon').length) {
  						$(this).find('img').after('<img src="https://cdn.shopify.com/s/files/1/1565/8379/files/YourPick.png?4972685469583793441" class="checkmarkIcon">');
  					}
  					$(this).siblings().find('.checkmarkIcon').remove();

  					return false;
  				}
  			})
  		}, 500)
  	}

  	function addYourPickIcon(element) {
  		if (!element.find('.checkmarkIcon').length) {
  			element.find('img').after('<img src="https://cdn.shopify.com/s/files/1/1565/8379/files/YourPick.png?4972685469583793441" class="checkmarkIcon">');
  		}
  		element.siblings().find('.checkmarkIcon').remove();
  	}

  	function markSelectedCollectionDisableOthers(collectionHandle, altCollectionChosen) {
  		$('.collectionDetailsWrapper').each(function() {
  			if ($(this).attr('aria-labelledby') == collectionHandle) {
  				$(this).find('.goToSwitchConfirmation').prop('disabled', true).text('selected');

  				// Add "Selected collection" warning to selected collection & remove warning from others
  				if (!$(this).find('.goToSwitchConfirmation').next().hasClass('selectedColWarning')) {
  					$(this).find('.altButtonWrapper').append('<p class="selectedColWarning">This is your selected collection.</p>')
  				}
  				$(this).siblings().find('.selectedColWarning').remove();

  				// if alt collection is chosen, disable all 'Get this collection' buttons
  				if (altCollectionChosen) {
  					$(this).siblings().find('.goToSwitchConfirmation').prop('disabled', true).text('select');
  					// console.log('disable true')
  				} else {
  					$(this).siblings().find('.goToSwitchConfirmation').prop('disabled', false).text('select');
  					// console.log('disable false')
  				}
  				return false;
  			}
  		})
  	}

  	function disableUnavailableVariants(element) {
  		var unavailableTops = false;
  		var unavailableBras = false;
  		var unavailableBottoms = false;
  		var unavailableJackets = false;

  		element.find('input[name="soldOutVariants"]').each(function() {
  			var $this = $(this);
  			var type = $this.val().split(' - ')[0].toUpperCase();
  			var size = $this.val().split(' - ')[1].toUpperCase();

  			// console.log('size:', size);
  			// console.log('braSize.text', $('.sizeConfirmationWrapper .braSize').html());

  			if (type.indexOf('BRA') > -1) {
  				unavailableBras = true;
  				displayUnavailableWarning('.braSize', size);
  			}
  			if (type.indexOf('LEGGINGS') > -1) {
  				unavailableBottoms = true;
  				displayUnavailableWarning('.bottomSize', size);
  			}
  			if (type.indexOf('TOPS') > -1) {
  				unavailableTops = true;
  				displayUnavailableWarning('.topSize', size);
  			}
  			if (type.indexOf('JACKET') > -1) {
  				displayUnavailableWarning('.jacketSize', size);
  			}
  			if (type.indexOf('WRAP') > -1) {
  				displayUnavailableWarning('.wrapSize', size);
  			}
  			if (unavailableBras == false) {
  				removeUnavailableWarning('.braSize');
  			}
  			if (unavailableBottoms == false) {
  				removeUnavailableWarning('.bottomSize');
  			}
  			if (unavailableTops == false) {
  				removeUnavailableWarning('.topSize');
  			}
  			if (unavailableJackets == false) {
  				removeUnavailableWarning('.jacketSize');
  			}
  		})
  	}

  	function displayUnavailableWarning(itemType, size) {
  		var element = '.sizeConfirmationWrapper ' + itemType;

  		if ($(element).html() == size) {
  			if (!$(element).next().hasClass('sizeUnavailable')) {
  				$(element).after('<p class="sizeUnavailable">This size is not available for this collection. Please choose another size or collection.</p>')
  			}
  		} else {
  			if ($(element).next().hasClass('sizeUnavailable')) {
  				$(element).next().remove();
  			}
  		}
  	}

  	function removeUnavailableWarning(itemType) {
  		var element = '.sizeConfirmationWrapper ' + itemType;

  		if ($(element).next().hasClass('sizeUnavailable')) {
  			$(element).next().remove();
  		}
  	}

  	function greyOutUnavailableSizes(element) {
  		var unavailableTops = false;
  		var unavailableBras = false;
  		var unavailableBottoms = false;

  		element.find('input[name="soldOutVariants"]').each(function() {
  			var $this = $(this);
  			var type = $this.val().split(' - ')[0].toUpperCase();
  			var size = $this.val().split(' - ')[1].toUpperCase();

  			if (type.indexOf('BRA') > -1) {
  				$('select[name="Bra_Size"] option').each(function() {
  					disableSpecificVariant($(this), size);
  				})
  			}
  			if (type.indexOf('LEGGINGS') > -1) {
  				$('select[name="Bottom_Size"] option').each(function() {
  					disableSpecificVariant($(this), size);
  				})
  			}
  			if (type.indexOf('TOPS') > -1) {
  				// console.log('TOPS!')
  				$('select[name="Top_Size"] option').each(function() {
  					disableSpecificVariant($(this), size);
  				})
  			}
  			if (type.indexOf('JACKET') > -1) {
  				$('select[name="Jacket_Size"] option').each(function() {
  					disableSpecificVariant($(this), size);
  				})
  			}
  			if (type.indexOf('WRAP') > -1) {
  				$('select[name="Wrap_Size"] option').each(function() {
  					disableSpecificVariant($(this), size);
  				})
  			}

  		})
  	}

  	function disableSpecificVariant(element, size) {
  		if (element.val() == size) {
  			element.attr('disabled', true);
  		}
  	}

  	function enableAllVariants() {
  		$('.sizeUnavailable').each(function() {
  			$(this).remove();
  		})

  		$('.updateSizes option').each(function() {
  			$(this).attr('disabled', false);
  		})
  	}

  	// function selectFirstAvailableVariant() {
  	// 	$('.updateSizesForm select').each(function() {
  	// 		$(this).find('option').each(function() {
  	// 			if ($(this).attr('disabled') != 'disabled') {
  	// 				$(this).prop('selected', 'selected');
  	// 				return false;
  	// 			}
  	// 		})
  	// 	})
  	// }

  	function populateSizesOnUpdateSizesView(element, itemSize) {
  		if (element.val() == itemSize && element.attr('disabled') != 'disabled') {
  			element.prop('selected', true);
  			return false;
  		}
  	}

    function appendSliderArrows(element) {
    	var previous = element + ' .lSPrev';
    	var next = element + ' .lSNext';
    	$(previous).append('<img src="https://cdn.shopify.com/s/files/1/1565/8379/files/left-arrow_1_copy.png?1423" style="width:20px;">');
    	$(next).append('<img src="https://cdn.shopify.com/s/files/1/1565/8379/files/right-arrow_1_copy.png?1423" style="width:20px;">');
    }

    function openTabPanelMobile(e) {
      // var $el = $(e.target);
      var $el = e;
      var id = $el.attr('id');
      var linkToDiv = '#' + id;
      var selection = $('#selectCustomerSubscription').val();

      // TODO: Grey skip button
      if ($el.attr('data-disabled')) {
        return false;
      }

      if ($el.hasClass('selected-tab')) {
        $el.removeClass('selected-tab');

        $('.tabbedSectionWrapperAccordian .panel').each(function() {
          if ($(this).attr('aria-labelledby') == $el.attr('aria-labelledby')) {
            $(this).hide();
          }
        })
      } else {
        $el.addClass('selected-tab');
        $el.siblings().removeClass('selected-tab');

        $('.tabbedSectionWrapperAccordian .panel').each(function() {
          if ($(this).attr('aria-labelledby') == $el.attr('aria-labelledby')) {
            $(this).show();
          }
          else {
            $(this).hide();
          }
        })

        if (selection.length < 2) {
          noSubscriptionSelected();
          location.href = linkToDiv;
          return false;
        }

        addYourPickIconMobile();

        location.href = linkToDiv;

      }
    }

    function addYourPickIconMobile() {
      var selectedCollection;
      var subscriptionID = $('#selectCustomerSubscription').val();

      $('#selectCustomerSubscription option').each(function() {
        if ($(this).val() == subscriptionID) {
          selectedCollection = $(this).text().split(' -')[0].split('. ')[1];
        }
      })

      setTimeout(function() {
        $('.showOnMobile798 .thisMonthsCollection.lslide').each(function() {
          if ($(this).find('h4').text() == selectedCollection) {

            if (!$(this).find('.checkmarkIcon').length) {
              $(this).find('img').after('<img src="https://cdn.shopify.com/s/files/1/1565/8379/files/YourPick.png?4972685469583793441" class="checkmarkIcon">');
            }
            $(this).siblings().find('.checkmarkIcon').remove();

            return false;
          }
        })
      }, 500)
    }

    function addYourPickIcon(element) {
      if (!element.find('.checkmarkIcon').length) {
        element.find('img').after('<img src="https://cdn.shopify.com/s/files/1/1565/8379/files/YourPick.png?4972685469583793441" class="checkmarkIcon">');
      }
      element.siblings().find('.checkmarkIcon').remove();
    }
  }
})
